<template>
  <b-card title="گزارش ترکر" class="report">
    <b-row>
      <b-col class="col-12 col-md-8 offset-md-2">
        <div class="d-flex my-2">
          <b-form-radio
              v-model="type"
              name="کانال تبلیغاتی"
              value="channel"
              class="mr-4"
          >
            کانال تبلیغاتی
          </b-form-radio>
          <b-form-radio
              v-model="type"
              name="کمپین"
              value="campaign"
              class="mr-4"
          >
            کمپین
          </b-form-radio>
          <b-form-radio
              v-model="type"
              name="اتریبیوشن"
              value="attribution"
          >
            اتریبیوشن
          </b-form-radio>
        </div>
        <b-row class="mb-3 pb-1 border-bottom">
          <b-col class="col-12 col-md-5">
            <b-form-group v-if="type === 'channel'" label="کانال">
              <channel-select v-model="id" />
            </b-form-group>
            <b-form-group v-if="type === 'campaign'" label="کمپین">
              <campaign-select v-model="id" />
            </b-form-group>
            <b-form-group v-if="type === 'attribution'" label="اتریبیوشن">
              <attribution-select v-model="id" />
            </b-form-group>
          </b-col>
          <b-col class="col-md-3">
            <b-form-group label="از تاریخ">
              <date-picker
                  v-model="fromDate"
                  placeholder=""
                  type="date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jD"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-md-3">
            <b-form-group label="تا تاریخ">
              <date-picker
                  v-model="toDate"
                  placeholder=""
                  type="date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jD"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-md-1 d-flex align-items-end">
            <b-button
                variant="warning"
                class="btn-icon mb-1"
                @click="getData"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-overlay :show="loading" rounded="md">
          <b-row class="mb-2">
            <b-col class="col-12 col-md-6" style="margin-bottom: 5px">
              <b-card bg-variant="light" class="mb-0">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                    <h3>
                      <span v-if="data.Cost">
                        <span class="font-medium-5 font-weight-bolder" style="margin-left: 8px">{{ data.Cost | price }}</span>
                        <span class="font-small-3 text-muted">تومان</span>
                      </span>
                      <span v-else class="font-medium-5 font-weight-bolder">0</span>
                    </h3>
                    <span class="text-black-50">کل هزینه</span>
                  </div>
                  <b-avatar
                      size="40"
                      variant="light-warning"
                  >
                    <feather-icon
                        size="20"
                        icon="DollarSignIcon"
                    />
                  </b-avatar>
                </div>
                <b-button
                    variant="primary"
                    size="sm"
                    :disabled="!data.Charge || !data.Charge.length"
                    @click="showCharges = !showCharges"
                >
                  {{ showCharges ? 'بستن لیست هزینه ها' : 'مشاهده لیست هزینه ها' }}
                </b-button>
                <table v-if="showCharges && data.Charge && data.Charge.length" class="w-100 mt-2">
                  <tr v-for="(item, i) in data.Charge" :key="i" class="border-bottom">
                    <td v-text="item.AttributionTitle" style="padding: 5px" />
                    <td style="padding: 5px">{{ item.Amount | price }}</td>
                  </tr>
                </table>
              </b-card>
            </b-col>
            <b-col class="col-12 col-md-6" style="margin-bottom: 5px">
              <b-card bg-variant="light" class="mb-0" style="height: 136px">
                <div class="h-100 d-flex justify-content-between align-items-center">
                  <div>
                    <h3>
                      <span v-if="data.Income">
                        <span class="font-medium-5 font-weight-bolder" style="margin-left: 8px">{{ data.Income | price }}</span>
                        <span class="font-small-3 text-muted">تومان</span>
                      </span>
                      <span v-else class="font-medium-5 font-weight-bolder">0</span>
                    </h3>
                    <span class="text-black-50">کل درامد</span>
                  </div>
                  <b-avatar
                      size="40"
                      variant="light-success"
                  >
                    <feather-icon
                        size="20"
                        icon="TrendingUpIcon"
                    />
                  </b-avatar>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-tabs class="mb-3">
            <b-tab
                v-for="(item, i) in tabs"
                :key="i"
                :title="item.title"
            >
              <b-table
                  v-if="item.data.length"
                  :items="item.data"
                  :fields="fields"
                  responsive
              >
                <template #cell(SumPayment)="data">
                  {{ data.value | price }}
                </template>
              </b-table>
              <div v-else class="text-muted text-center font-small-3 my-3">اطلاعاتی وجود ندارد</div>
            </b-tab>
          </b-tabs>
          <div>
            <h4 class="font-medium-2 mb-1">لیست اتریبیوشن ها</h4>
            <b-table
                v-if="data.Attribution && data.Attribution.length"
                :items="data.Attribution"
                :fields="attributionFields"
                responsive
            >
              <template #cell(SumPayment)="data">
                {{ data.value | price }}
              </template>
            </b-table>
            <div v-else class="text-muted text-center font-small-3 my-3">اطلاعاتی وجود ندارد</div>
          </div>
        </b-overlay>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import CampaignSelect from "@/tools/campaign.vue";
import ChannelSelect from "@/tools/channel.vue";
import attributionSelect from "@/tools/attribution.vue";
import Table from "@core/mixins/table";

export default {
  name: "trackerReport",
  components: {Table, CampaignSelect, ChannelSelect, attributionSelect },
  data() {
    return {
      showCharges: false,
      loading: false,
      type: 'channel',
      id: '',
      fromDate: '',
      toDate: '',
      data: {},
      adTrace: [],
      metrix: [],
      fields: [
        {
          key: 'InstallStatus',
          label: 'وضعیت',
        },
        {
          key: 'Count',
          label: 'تعداد',
        },
        {
          key: 'SumPayment',
          label: 'مبلغ درامد',
        },
      ],
      attributionFields: [
        {
          key: 'AttributionTitle',
          label: 'عنوان',
        },
        {
          key: 'CampaignTitle',
          label: 'کمپین',
        },
        {
          key: 'ChannelTitle',
          label: 'کانال',
        },
      ]
    }
  },
  computed: {
    tabs() {
      return [
        { title: 'متریکس', data: this.metrix },
        { title: 'ادتریس', data: this.adTrace },
      ]
    }
  },
  watch: {
    type() {
      this.showCharges = false
      this.id = ''
      this.fromDate = ''
      this.toDate = ''
      this.data = {}
      this.adTrace = []
      this.metrix = []
    }
  },
  methods: {
    getData() {
      if (!this.id || !this.fromDate || !this.toDate) return
      let data = {
        FromDate: this.fromDate,
        ToDate: this.toDate,
      }
      if (this.type === 'channel') data.ChannelId = this.id
      else if (this.type === 'campaign') data.CampaignId = this.id
      else if (this.type === 'attribution') data.AttributionId = this.id

      this.loading = true

      this.$http.post(this.$api.attributions.report, data)
          .then(res => {
            this.data = res.data
            this.metrix = res.data.Metrix
            this.adTrace = res.data.AdTrace
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>